import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Search from "../../Search/Search";
import Add from "../../Buttons/Add";
import { usePopUpsStore } from "../../../store/PopUpStore";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import Table, { TableButtonLink, TableOperation } from "../../Table";
import { useParams } from "react-router-dom";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import Pagination from "../../pagination/Pagination (1)";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Loader from "../../Loader";

interface Semester {
  id: string | number;
  name: string;
  year: string;
  start_date: string;
  end_date: string;
  registration_start_date: string;
  registration_end_date: string;
  has_exception: string;
  max_fail_regular: number;
  max_fail_dropout: number;
  count_curriculums_optional: number;
  count_curriculums_mandatory: number;
  curriculums: Curriculums[];
  discounts: Discount[];
}

interface SemestersData {
  data: { data: Semester[]; last_page: number };
}
interface Curriculums {
  id: number;
  code: string;
  name_en: string;
  name_ar: string;
  min_pass_mark: number;
  theoretical_mark: number;
  practical_mark: number;
  assistances_marks: number;
  type: number;
  is_optional: boolean;
}

interface Discount {
  id: number;
  name: string;
  percentage: number;
  is_exhausted_student: boolean;
}

export default function New_Semester() {
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const { searchParams, handleParamsClick, handleParamDelete } = useFilter();

  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const { id } = useParams();
  
  const links: TableButtonLink[] = [
    {
      name: "الخصومات",

      link: `discount`,
      color: "red",
    },
    {
      name: "الرسوم الدراسية",

      link: "academic-fee",
      color: "red",
    },
  ];

  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const { data, isLoading } = useFetch(
    `admin/semesters?page=${page}&search=${search}`,
    `admin/semesters?page=${page}&search=${search}`
  );

  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );
  return (
    <>
      <Row>
        <Col>
          <Title title="الفصول الدراسية الجديدة" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder=" اسم الفصل"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>
      {isLoading && <Loader />}
      <Row justify="center">
        <Table<Semester>
          tableHeads={[
            "اسم الفصل",
            " السنة",
            "رقم الفصل",
            "تاريخ البدء",
            "تاريخ الانتهاء",

            "العمليات",
            "معلومات اضافية",
          ]}
          tableBody={data?.data?.data}
          keys={["name", "year", "id", "start_date", "end_date"]}
          operations={operations}
          links={links}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
      </Row>
      {data?.data?.data?.length > 0 && (
        <Pagination pageCount={data?.data?.last_page} />
      )}
      <PopUpDelete
        text="هل أنت متأكد من حذف هذا الفصل؟"
        onClickDelete={() => deleteItem(`admin/semesters/${popUpDelete[0]}`)}
      />

      <Add link="/new_semester/create_new_semester" />
    </>
  );
}
